// Copyright (c) StrangeBee 2023

import React, { ReactElement, useRef } from 'react';
import Content from './components/Content';
import Footer from './components/Footer';
import Header from './components/Header';
import { Slot } from './components/Slot';

import './THList.scss';
import { classList } from '@Helpers/className';

interface THListProps {
    children: ReactElement[] | ReactElement;
    className?: string;
}

const slotName = ['Header', 'Footer'];

export const THList = ({ children, className }: THListProps): ReactElement => {
    const contentRef = useRef<HTMLDivElement>(null);
    const element = Array.isArray(children) ? children : [children];

    const HeaderElem = (element as ReactElement[]).find(({ type }: any) => type?.displayName === slotName[0]);
    const FooterElem = (element as ReactElement[]).find(({ type }: any) => type?.displayName === slotName[1]);
    const ContentElem = (element as ReactElement[]).filter(({ type }: any) => !slotName.includes(type?.displayName));

    return (
        <div
            className={classList('th-list ', className)}
            style={{ gridTemplateRows: `${HeaderElem ? 'auto' : ''} 1fr ${FooterElem ? 'auto' : ''}` }}
        >
            {HeaderElem ? HeaderElem : null}
            <div className="th-list__body">
                {ContentElem
                    ? ContentElem.map((contentElem, index) =>
                          React.cloneElement(contentElem, { ref: contentRef, key: 'th-list-' + index }),
                      )
                    : null}
            </div>
            {FooterElem ? React.cloneElement(FooterElem, { ref: contentRef }) : null}
        </div>
    );
};

THList.Header = Header;
THList.Content = Content;
THList.Footer = Footer;
THList.Slot = Slot;
